export const TICKET_LIST_ENTRY_POINT = 'entry';
export const PIE_CHART_ENTRY_POINT_VALUE = 'fromPieChart';
